// 팀에서의 역할 판정 — Firestore 규칙(isTeamAdmin / isStaff / isTeamPerson)과
// iOS TeamMembershipService.inferMembership 과 같은 기준으로 계산한다.
//
// 기준은 팀 문서(teams/{teamId})의 ownerId / adminIds / coachIds / memberIds 뿐이다.
// teams/{t}/members/{uid}.role 은 규칙도 iOS 도 보지 않으므로 권한 판정에 쓰지 않는다.

const list = (v) => (Array.isArray(v) ? v : []);

export const rolesFor = (team, uid) => {
  if (!team || !uid) {
    return {
      isOwner: false, isAdmin: false, isCoach: false,
      isStaff: false, isMember: false, roleKey: 'none',
    };
  }
  const isOwner  = team.ownerId === uid;                      // 규칙 isOwnerOf
  const isAdmin  = isOwner || list(team.adminIds).includes(uid); // 규칙 isTeamAdmin
  const isCoach  = list(team.coachIds).includes(uid);
  const isStaff  = isAdmin || isCoach;                        // 규칙 isStaff
  const isMember = isStaff || list(team.memberIds).includes(uid); // 규칙 isTeamPerson
  return {
    isOwner, isAdmin, isCoach, isStaff, isMember,
    roleKey: isOwner ? 'owner' : isAdmin ? 'admin' : isCoach ? 'coach'
           : isMember ? 'member' : 'none',
  };
};

// 화면 표시용. 권한 판정에 쓰지 말 것 (판정은 위 불리언으로).
export const TeamRoles = {
  owner:  { label: '소유자', icon: '👑', color: '#F0B429' },
  admin:  { label: '운영자', icon: '🛡️', color: '#5BC4D8' },
  coach:  { label: '코치',   icon: '📋', color: '#A78BFA' },
  member: { label: '회원',   icon: '🏒', color: '#6B7280' },
  none:   { label: '-',      icon: '',   color: '#6B7280' },
};

// 쓰기 함수 앞에서 쓰는 가드. 버튼을 숨기는 것만으로는 막히지 않으므로
// 실제 쓰기 직전에 한 번 더 확인한다(규칙이 거부하기 전에 분명한 메시지를 준다).
export const requireRole = (roles, need) => {
  if (roles?.[need]) return true;
  const what = need === 'isAdmin' ? '팀 소유자 또는 운영자' : '팀 운영진(소유자·운영자·코치)';
  alert(`${what}만 할 수 있는 작업입니다.`);
  return false;
};
